document.addEventListener("DOMContentLoaded", function() {
    var customAdd = document.querySelector(".custom-rig-ads");
    var customOrderDiv = document.querySelector(".custom-orderr");
    var customContactDiv = document.querySelector(".custom-contant");
    var customRecentlyViewedDiv = document.querySelector(".custom-recently-viewed");
    var customTopSelling = document.querySelector(".custom-top-selling");
    var customTrackOrder = document.querySelector(".custom-track-ord");
    var customTicketsAPI = document.querySelector(".custom-tickets-api");
    var allLinks = document.querySelectorAll(".cstm-a");
    var subtitleText = document.getElementById("subtitle-text");

    function updateSubtitleText(newText) {
        subtitleText.textContent = newText;
    }

    function removeActiveClass() {
        allLinks.forEach(function(link) {
            link.classList.remove("active");
        });
        var headerLinks = document.querySelectorAll(".header-cstm-a");
        headerLinks.forEach(function(link) {
            link.classList.remove("active");
        });
    }

    function hideAllSections() {
        customAdd.style.display = "none";
        customOrderDiv.style.display = "none";
        customContactDiv.style.display = "none";
        customRecentlyViewedDiv.style.display = "none";
        customTopSelling.style.display = "none";
        customTrackOrder.style.display = "none";
        customTicketsAPI.style.display = "none";
    }

    function isMobileView() {
        return window.innerWidth <= 768; // Adjust width if needed
    }

  function scrollToSection(element) {
    if (!isMobileView() || !element) return; // Apply only on mobile

    if (element.getAttribute("data-scrolled") !== "true") { 
        setTimeout(() => {
            window.scrollTo({
                top: element.offsetTop - 160, // Adjust offset for better visibility
                behavior: "smooth"
            });
            element.setAttribute("data-scrolled", "true"); // Mark as scrolled
        }, 50);
    }
}


    function activateTab(tabName) {
        hideAllSections();
        removeActiveClass();
        var linkToActivate = document.querySelector(`.cstm-a[href*='${tabName}']`);
        var headerLinkToActivate = document.querySelector(`.header-cstm-a[href*='${tabName}']`);

        if (linkToActivate) {
            linkToActivate.classList.add("active");
            updateSubtitleText(linkToActivate.getAttribute("data-subtitle"));
        }
        if (headerLinkToActivate) {
            headerLinkToActivate.classList.add("active");
        }

        let sectionToShow;
        switch (tabName) {
            case "my_order":
                customOrderDiv.style.display = "block";
                sectionToShow = customOrderDiv;
                break;
            case "contact":
                customContactDiv.style.display = "block";
                sectionToShow = customContactDiv;
                break;
            case "recently_viewed":
                customRecentlyViewedDiv.style.display = "block";
                sectionToShow = customRecentlyViewedDiv;
                break;
            case "top_order_products":
                customTopSelling.style.display = "block";
                sectionToShow = customTopSelling;
                break;
            case "track_order":
                customTrackOrder.style.display = "block";
                sectionToShow = customTrackOrder;
                break;
            case "tickets":
                customTicketsAPI.style.display = "block";
                sectionToShow = customTicketsAPI;
                break;
            default:
                customAdd.style.display = "block";
                sectionToShow = customAdd;
                var defaultLink = document.querySelector(".cstm-a[href='/account']");
                var defaultHeaderLink = document.querySelector(".header-cstm-a[href='/account']");
                if (defaultLink) {
                    defaultLink.classList.add("active");
                    updateSubtitleText(defaultLink.getAttribute("data-subtitle"));
                }
                if (defaultHeaderLink) {
                    defaultHeaderLink.classList.add("active");
                }
                break;
        }

        // Scroll to the active section only in mobile view
        scrollToSection(sectionToShow);
    }

    var urlParams = new URLSearchParams(window.location.search);
    var activeTab = urlParams.get("tab");
    if (activeTab) {
        activateTab(activeTab);
    } else {
        activateTab(""); // Activate the default tab if no tab is specified
    }

    allLinks.forEach(function(link) {
        link.addEventListener("click", function(event) {
            var tab = link.getAttribute("href").split("=")[1];
            if (tab) {
                event.preventDefault();
                history.pushState(null, "", `/account?tab=${tab}`);
                activateTab(tab);
            } else {
                removeActiveClass();
                link.classList.add("active");
                history.pushState(null, "", "/account");
                updateSubtitleText(link.getAttribute("data-subtitle"));
                hideAllSections();
                customAdd.style.display = "block";
                scrollToSection(customAdd);
            }
        });
    });

    document.addEventListener("click", function(event) {
        if (event.target.matches(".header-cstm-a")) {
            var tab = event.target.getAttribute("href").split("=")[1];
            if (tab) {
                event.preventDefault();
                history.pushState(null, "", `/account?tab=${tab}`);
                activateTab(tab);
            }
        }
    });

    window.addEventListener("resize", function() {
        if (isMobileView()) {
            var activeSection = document.querySelector(".active");
            if (activeSection) {
                scrollToSection(activeSection);
            }
        }
    });
});
